var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-switch',{on:{"change":_vm.change},model:{value:(_vm.switchVal),callback:function ($$v) {_vm.switchVal=$$v},expression:"switchVal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }